import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "@/lib/smooth";

const links = [
  { label: "About", href: "#about" },
  { label: "Nisha", href: "#nisha" },
  { label: "Offerings", href: "#offerings" },
  { label: "Retreats", href: "#retreats" },
  { label: "Events", href: "#events" },
  { label: "FAQ", href: "#faq" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    scrollToId(href);
  };

  return (
    <motion.header
      data-testid="main-nav"
      initial={{ y: -90 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
      style={{ top: "var(--banner-h, 0px)" }}
      className={`fixed inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "bg-[#FAF7F2]/80 backdrop-blur-xl border-b border-[#8C8070]/20"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1400px] px-5 md:px-10 h-[92px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0) || window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
          aria-label="Pause. home"
        >
          <img src="/images/logo.png" alt="Pause." className="h-20 w-20 object-contain" />
        </button>

        <div className="hidden min-[900px]:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-body text-[13px] uppercase tracking-[0.14em] text-[#1A1A1A]/80 hover:text-[#1A1A1A] transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#3B5A3A] hover:after:w-full after:transition-[width] after:duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <button
          data-testid="nav-join-cta"
          onClick={() => scrollToId("#waitlist")}
          className="font-body text-[13px] uppercase tracking-[0.12em] font-medium bg-[#F5C800] text-[#1A1A1A] px-5 py-2.5 rounded-full hover:scale-[1.04] hover:shadow-[0_8px_30px_rgba(245,200,0,0.35)] transition-transform duration-300"
        >
          Join the List
        </button>
      </nav>
    </motion.header>
  );
};
